import axios from "axios";
// 环境的切换
// axios.defaults.baseURL = "/";
// axios.defaults.baseURL = "http://127.0.0.1:8000/";
// axios.defaults.baseURL = "https://5g.scsjb.cn/";
axios.defaults.baseURL = "/";
// axios.defaults.baseURL = 'https://www-demo.scsjb.cn/'
//设置超时时间
axios.defaults.timeout = 10000;
// post请求头
axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";
axios.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
// axios.defaults.withcredentials = true;
axios.defaults.withCredentials = true;
//请求拦截(请求发出前处理请求)
axios.interceptors.request.use(
  (config) => {
    // //在发送请求之前如果为post序列化请求参数
    // if (config.method == 'post') {
    //     config.data = config.data;
    // }
    // // config.url = config.url = "?"
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 响应拦截器（处理响应数据）
axios.interceptors.response.use(
  (res) => {
    return res;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  },
);

// 封装get方法
function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, { params: params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

// 封装post方法
function post(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

//对外接口
export function request({ method, url, data }) {
  if (method == "get") {
    return get(url, data);
  } else if (method == "post") {
    return post(url, data);
  }
}

export default {
  install(Vue) {
    Vue.prototype.$axios = axios;
    Vue.prototype.$request = function () {
      return request;
    };
  },
};
